import styled from '../../config/theme'

const Container = styled.div`
  display: flex;
  flex-direction: column;

  > button {
    margin: 10px 0;

    span {
      flex: 1;
      text-align: left;
    }
  }
`

export {
  Container,
}
